import type { PublicApi, JoinedGameInfo, AuthenticatedData } from './Client.js';
export { PublicApi, JoinedGameInfo, AuthenticatedData }
export { type ClientApiRegistry, type IClientSystem, isClientSystem, ClientSystem } from './IClientSystem.js';
export { CLIENT_SYSTEM_PROTO } from './clientSystemMethods.js';
import { Client } from './Client.js';
export { Client };
export type { ClientGameFile, ClientAreaFile, ClientConfig } from './Client.js';
export { ClientProcess, type JoinedAreaData } from './ClientProcess.js';
export { getAreaIdsForSystem, resolveAreaForSystem, type AreaRoutingProcess } from './areaRouting.js';
export { HotCodeSystem, type HotCodeSystemOptions } from './HotCodeSystem.js';

export * from '@gotti/core';

import { coreUtils } from '@gotti/core';
import * as ClientUtils from './utils.js';

const Utils = {
  ...coreUtils,
  ...ClientUtils,
}
export { Utils }

// Debug system exports
export * from './debug/index.js';


function defaultExportFail(name: string) {
    return (...args: any[]) => {
        throw new Error(`Instantiate a new client object before calling ${name} from the default Gotti export.`);
    }
}

const Gotti: PublicApi = {
    off: defaultExportFail('off'),
    on: defaultExportFail('on'),
    emit: defaultExportFail('emit'),
    once: defaultExportFail('once'),
    removeAllListeners: defaultExportFail('removeAllListeners'),
    clearGame: defaultExportFail('clearGame'),
    getGames:defaultExportFail('clearGame'),
    joinInitialAreas: defaultExportFail('joinInitialAreas'),
    joinArea: defaultExportFail('joinArea'),
    joinGame: defaultExportFail('clearGame'),
    startGame: defaultExportFail('clearGame'),
    authenticate: defaultExportFail('clearGame'),
    auth: null,
};

let currentClient : Client | null = null;

export const setDefaultClientExport = function(client: Client) {
    // clear properties on Gotti in case we already had a client initialized
    currentClient = client;
    Object.keys(Gotti).forEach(key => {
      Object.defineProperty(Gotti, key, {
          writable: true
      });
       delete Gotti[key];
    });
    Object.keys(client.publicApi).forEach(key => {
        Gotti[key] = client.publicApi[key];
        Object.defineProperty(Gotti, key, {
            writable: false
        });
    });
};

export const getCurrentClient = () : Client | null => {
  return currentClient
}

export default Gotti;